var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qx-card',{attrs:{"title":"资产看板"}},[_c('iframe',{staticClass:"frameBox",attrs:{"src":_vm.frameUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }